module.exports = __webpack_public_path__ + "static/favicon-5555f1e0877bc5444be9ffcbc1d47189.ico";